import React, { useEffect } from 'react';
import styled from 'styled-components';
import { number, func, string, object } from 'prop-types';
import { discountModalView, useDiscountClick } from '../../../services/tracking';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: ${({ open }) => ((open) ? 'block' : 'none')};
  z-index: 100;
`;

const Container = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  position: relative;
  width: 250px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  padding: 32px;
  text-align: center;
  border-radius: 5px;

  @media(min-width: 1000px) {
    width: 642px;
  }
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: bold;
  line-height: 1.33;
  text-align: center;
  color: #4a4a4a;
  padding: 0px 100px;

  @media(min-width: 1000px) {
    font-size: 36px;
  }
`;

const Text = styled.div`
  margin-top: ${({ marginTop }) => marginTop || '16px'};
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  color: #4a4a4a;
  margin-bottom: 16px;
  padding: 0px 60px;

  @media(min-width: 1000px) {
    font-size: 20px;
  }
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  margin-top: 20px;

  @media(min-width: 1000px) {
    flex-direction: row;
    justify-content: space-evenly;
  }
`;

const LeaveButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 250px;
  line-height: 2.4;
  height: 64px;
  border-radius: 100px;
  font-size: 16px;
  color: #f78323;
  background-color: #ffffff;
  border: 1px solid #f78323;
  margin: 10px 0;

  @media(min-width: 1000px) {
    width: 204px;
  }
`;

const ContinueButton = styled.button`
  cursor: pointer;
  width: 250px;
  line-height: 1.5;
  height: 64px;
  border-radius: 100px;
  font-size: 16px;
  text-align: center;
  color: #ffffff;
  background-color: #f78323;
  border: none;

  @media(min-width: 1000px) {
    width: 204px;
  }
`;

const Divisor = styled.span`
  display: block;
  border-top: solid 0.8px #D2D2D2;
  margin: 30px 0px;
`;

const DiscountText = styled.span`
  color: white;
  background-color: #10CE64;
  padding: 2px 8px;
`;

const HelpIcon = styled.img`
  margin: 23px 0px;
  cursor: pointer;
`;

const handleUseDiscountClick = (funnelId, closeFunc) => {
  //eslint-disable-next-line
  useDiscountClick({ pointOfSale: 'free-insertion', funnelId });
  closeFunc();
};

const handleWithouthDiscountClick = (funnelId, closeFunc) => {
  closeFunc();
};

const getModalMessage = (message) => {
  const discountMessageArray = message.split('**');
  return (
    <Text marginTop="24px">
      {discountMessageArray[0]}<DiscountText>{discountMessageArray[1]}</DiscountText>{discountMessageArray[2]}
    </Text>
  );
};

const ConfirmationModal = ({
  discountAmount, onClose, funnelId, discountMessage,
}) => {
  useEffect(() => {
    discountModalView({ pointOfSale: 'free-insertion', funnelId });
  });
  return (
    <Overlay open={discountAmount} onClick={onClose}>
      <Container data-e2e="modal-container" onClick={event => event.stopPropagation()}>
        <HelpIcon src={`${process.env.PUBLIC_URL}/images/pig.svg`} />
        <Title>{discountMessage.title}</Title>
        {getModalMessage(discountMessage.default)}
        <Divisor />
        <Text>
          Tem certeza que quer continuar sem destaque?
        </Text>
        <Footer>
          <LeaveButton onClick={() => handleWithouthDiscountClick(funnelId, onClose)}>Não quero desconto</LeaveButton>
          <ContinueButton onClick={() => handleUseDiscountClick(funnelId, onClose)}>Aproveitar desconto</ContinueButton>
        </Footer>
      </Container>
    </Overlay>
  );
};

ConfirmationModal.propTypes = {
  discountAmount: number.isRequired,
  onClose: func.isRequired,
  funnelId: string.isRequired,
  discountMessage: object,
};
ConfirmationModal.defaultProps = {
  discountMessage: null,
};

export default ConfirmationModal;
